import React, { useContext, useEffect, useState } from "react";
import { Box, TextField, Typography, useTheme } from "@material-ui/core";
import { useForm } from "react-hook-form";
import Text from "../../../../../shared/components/Text";
import MainButton from "../../../../../shared/components/MainButton";
import IconTitle from "../../../../../shared/components/IconTitle";
import { ICON_TITLE_HEIGHT } from "../../../../../../config/config";
import { assetIds, ThemedAsset } from "nemuru-components";
import { infoDataCupsNumber } from "../../config";
import AdditionalDataCupsInformationDialog from "../components/AdditionalDataCupsInformationDialog";
import { CUPS_REGEX } from "../../../../../../utils/validations";
import { formatDeleteSpacesInStringAndUpperCase } from "../../../../../../utils/formaters";
import { PatchAssetDetailsByLoanId } from "../../../../../../utils/mappers/PatchAssetDetailsByLoanId";
import { ProcessContext } from "../../../../../../contexts/ProcessContext";

export default function AdditionalDataCupsNumberForm({ onSubmitForm, data }) {
  const { palette } = useTheme();

  const {
    state: { loan, lastActionsReference, lastActionsReferenceLastChange },
    dispatch,
  } = useContext(ProcessContext);

  const [state, setState] = useState({
    showDialog: false,
  });

  const { showDialog } = state;

  const { register, watch, getValues, handleSubmit, errors } = useForm({
    defaultValues: {
      cupsCode: data?.cupsCode || "",
    },
  });

  const onCloseDialog = () => {
    setState((s) => ({ ...s, showDialog: false }));
  };

  const cupsCode = watch("cupsCode");

  const onSubmitStep = () => {
    dispatch({
      type: "SET_FLOW_LOADING",
      payload: { show: true },
    });
    const body = PatchAssetDetailsByLoanId.dehydrate({
      loanId: loan.id,
      assetType: loan.asset_reference[0].type,
      cups: cupsCode,
    });
    dispatch({
      type: "PROCESS_PATCH_ASSET_DETAILS_BY_LOAN_ID",
      payload: body,
    });
  };

  useEffect(() => {
    const isActionTypeInLastActionsReference = (actionType) =>
      lastActionsReference?.some((element) => element.type === actionType);
    if (
      isActionTypeInLastActionsReference(
        "PROCESS_PATCH_ASSET_DETAILS_BY_LOAN_ID_FULFILLED"
      )
    ) {
      dispatch({
        type: "SET_FLOW_LOADING",
        payload: { show: false },
      });
      onSubmitForm(getValues());
    }
  }, [lastActionsReferenceLastChange]);

  return (
    <>
      {showDialog && (
        <AdditionalDataCupsInformationDialog
          infoData={infoDataCupsNumber}
          onClose={onCloseDialog}
        />
      )}
      <Box className="appear-anim">
        <IconTitle
          icon={
            <ThemedAsset
              id={assetIds.ICON_BANK}
              width={ICON_TITLE_HEIGHT}
              height={ICON_TITLE_HEIGHT}
              style={{ color: palette.secondary.main }}
            />
          }
          title={<Text tId="ADDITIONAL_INFORMATION" />}
          subtitle={<Text tId="CUPS_SUPPLY_CODE" />}
        />
        <TextField
          fullWidth
          value={
            cupsCode ? formatDeleteSpacesInStringAndUpperCase(cupsCode) : ""
          }
          label={<Text tId={"CUPS_CODE"} />}
          type="text"
          id="cupsCode"
          name="cupsCode"
          error={errors.cupsCode}
          helperText={errors.cupsCode?.message}
          inputProps={{
            ref: register({
              required: {
                value: true,
                message: <Text tId={"REQUIRED_FIELD"} />,
              },
              pattern: {
                value: CUPS_REGEX,
                message: <Text tId={"INVALID_CUPS_NUMBER"} />,
              },
            }),
          }}
        />
        <Typography
          variant="caption"
          onClick={() => setState((s) => ({ ...s, showDialog: true }))}
          style={{ cursor: "pointer", textDecoration: "underline" }}
        >
          <Text tId="HOW_TO_FIND_CUPS" />
        </Typography>
      </Box>
      <Box className="appear-anim">
        <MainButton onClick={handleSubmit(() => onSubmitStep())} />
      </Box>
    </>
  );
}
